import { Typography, Box } from "@mui/material" 
import FormDescription from "../../../../inputFormComponents/FormDescription"
import image from './../../../../resources/InvoiceTextTemplates.png'

const DescriptionTextTemplates = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Textbausteine:</Typography>
          <Typography variant="body2">Die Textbausteine werden je nach Rechnungsart, Grund- und Kundeeinstellungen vorkonfiguriert und können durch entsprechende Anpassungen jederzeit abgeändert oder ergänzt werden.</Typography>
        </Box>
      ]}
      image={image}
    />
  )
}

export default DescriptionTextTemplates